import { render, staticRenderFns } from "./CurrentSpecialist.vue?vue&type=template&id=de41e516&scoped=true&"
import script from "./CurrentSpecialist.vue?vue&type=script&lang=js&"
export * from "./CurrentSpecialist.vue?vue&type=script&lang=js&"
import style0 from "./CurrentSpecialist.vue?vue&type=style&index=0&id=de41e516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de41e516",
  null
  
)

export default component.exports